"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Soleil et Plage"}
        backgroundImgSrc={"/images/card-title/Nature-Biodiversite.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Soleil et Plage</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Nature & Biodiversité */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Soleil et Plage"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Les charmes naturels de la Côte d’Ivoire s’expriment à travers une
          vaste étendue de côte baignant dans l’Océan Atlantique. De Assinie à
          Jacqueville ou encore de Fresco à Tabou en passant par la belle
          Grand-Béréby avec une mer encore pure et propre au niveau des côtes
          vierges des plages d’exceptions ou se côtoient harmonieusement sable
          fin, cocotier et paysage rocheux.
          <br />
          <br />
          En parcourant la côte ivoirienne, vous assistez à une riche succession
          de brousse et de littoral. Pendant que vous vous perdez dans ce
          paysage naturel et encore sauvage de végétation dense, vous êtes
          surpris par des villages, l’océan et quelques pirogues de pêcheurs que
          vous pouvez apercevoir au loin. Les animaux tels que les chimpanzés
          font irruption sur le chemin parfois comme pour vous souhaiter
          l’Akwaba.
          <br />
          <br />
          Le clou de ce voyage sera sans nul doute un bain dans les eaux suaves
          des fameuses piscines naturelles de la plage de Taboulé du côté de
          Grand-Béréby après une halte pour admirer les futures mamans tortues
          présentes pour la ponte et s’amuser de la locomotion caractéristique,
          sur le côté, des crabes.
          <br />
          <br />
          Que vous cherchiez l’aventure en naviguant à la recherche des plages
          intimes ou que vous préfériez vous détendre seul, en couple en famille
          ou entre amis, c’est le moment de choisir votre coin de paradis sur
          terre pour vous ressourcer.
        </AwesomeCard>
      </SectionPage>

      {/* Quiétude et Félicité */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={'mt-1'}>
            <ImageGallery images={
              Array.from({ length: 4 }).map((_, index) => ({
                src: `/images/nature-biodiversite/galerie2/${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
